import { render, staticRenderFns } from "./goodsOnput.vue?vue&type=template&id=005933b0&scoped=true&"
import script from "./goodsOnput.vue?vue&type=script&lang=js&"
export * from "./goodsOnput.vue?vue&type=script&lang=js&"
import style0 from "./goodsOnput.vue?vue&type=style&index=0&id=005933b0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "005933b0",
  null
  
)

export default component.exports